import { useParams } from 'react-router-dom'
import { useQuery } from '@apollo/client/react'
import { GET_WORKSPACES_BY_ID } from 'graphql/queries/workspaces/workspaceQueries'

const useWorkspaceInfo = () => {
  const { workspaceId } = useParams()

  const hasValidWorkspaceId = workspaceId && workspaceId.startsWith('WRK-')

  const { data } = useQuery(GET_WORKSPACES_BY_ID, {
    variables: { ids: hasValidWorkspaceId ? [workspaceId] : [] },
    skip: !hasValidWorkspaceId,
  })

  const workspace = data?.getWorkspacesByID?.[0]

  return { workspace }
}

export default useWorkspaceInfo
